import { Button } from 'components/button/Button'
import { ThemedTextImageSection } from 'components/content/themedTextImageSection/ThemedTextImageSection'
import { useCreateDirectiveLogic } from 'components/directive/utils/directiveUtils'
import { ContentfulImage } from 'components/Image'
import { Caption, Text } from 'components/Typography'
import { describeSimpleDirectiveFlow } from 'logic/directive/describe'
import { SimpleFlowDirectiveType } from 'logic/directive/types'
import { Trans, useTranslation } from 'next-i18next'
import { FC } from 'react'
import { colors } from 'utils/colors'
import { useContentfulImages } from 'utils/contentful/ContentfulImagesContext'
import { toLowerCase } from 'utils/general'
import { BREAKPOINTS } from 'utils/styled'

export type WhyDirectiveSectionProps = {
  directiveType: SimpleFlowDirectiveType
}

export const WhyDirectiveSection: FC<WhyDirectiveSectionProps> = (props) => {
  const { directiveType } = props
  const images = useContentfulImages()
  const namespace = `${toLowerCase(props.directiveType)}_lp` as const

  const { t } = useTranslation(namespace, {
    keyPrefix: `${namespace}.section_why`,
  })

  const analyticsPlace =
    directiveType === 'WILL' ? 'will_lp' : directiveType === 'TRUST' ? 'trust_lp' : undefined

  const { create } = useCreateDirectiveLogic(directiveType, {
    place: analyticsPlace,
  })

  const { getButtonTone } = describeSimpleDirectiveFlow(props.directiveType).landingPage()

  return (
    <ThemedTextImageSection
      title={t('title')}
      image={<ContentfulImage {...images[`${namespace}_why`]} />}
    >
      <Text>
        <Trans
          t={t}
          i18nKey="description"
          components={[
            <Caption key="0" style={{ color: colors.black, marginBottom: 0, marginTop: '1rem' }} />,
          ]}
        />
      </Text>
      <Button
        onClick={create}
        type="button"
        variant="primary"
        size="large"
        tone={getButtonTone()}
        css={[
          { alignSelf: 'start' },
          BREAKPOINTS.MD.css({
            width: '100%',
          }),
        ]}
      >
        <Trans t={t} i18nKey="start_button" />
      </Button>
    </ThemedTextImageSection>
  )
}
